import { z } from 'zod';

import { levelEnumValidator, uuidValidator } from '../../validators';
import { WordResponseSchema } from '../words';

export const SentenceResponseSchema = z.object({
  id: uuidValidator,
  level: levelEnumValidator,
  text: z.string(),
  translation: z.string().nullable(),
  userId: uuidValidator,
  words: z.array(WordResponseSchema).optional(),
});

export type ISentenceResponseDto = z.infer<typeof SentenceResponseSchema>;
